import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase";

// Firebase Storage upload helper.
// Takes a browser File (from an <input type="file"> / antd Upload) and returns a download URL.
// Used by the `useFirebaseUpload` hook in helper.js.

/**
 * Upload a File to Firebase Storage. Returns the download URL (or null on failure).
 * @param {File} file     browser File object
 * @param {string} folder storage folder/prefix, e.g. "property-images"
 */
export const uploadFile = async (file, folder = "uploads") => {
  try {
    const ext = (file.name?.split(".").pop() || "jpg").toLowerCase();
    const fileName = `${folder}/${Date.now()}-${Math.random()
      .toString(36)
      .substring(7)}.${ext}`;

    const storageRef = ref(storage, fileName);
    await uploadBytes(storageRef, file, {
      contentType: file.type || "application/octet-stream",
    });

    return await getDownloadURL(storageRef);
  } catch (error) {
    console.error("[firebase storage] upload failed:", error?.message || error);
    return null;
  }
};
